import React from 'react'
import classNames from 'classnames'
import IconHome from 'components/partials/IconHome'

function Breadcrumb({ links = [], modifierClasses = [], disabled }) {
  const breadcrumbClasses = classNames(
    'breadcrumb',
    'breadcrumb--search',
    modifierClasses,
  )

  return Boolean(links.length) && (
    <ol className={breadcrumbClasses}>
      {links.map((link, index) => (
        <li className="breadcrumb__item u-text-lowercase u-font-weight-500">
          {link.url ? (
            <a className="breadcrumb__link" href={link.url}>
              {index === 0 ? (
                <>
                  <IconHome />
                  <span className="visually-hidden">{link.displayName}</span>
                </>
              ) : (
                <>{link.displayName}</>
              )}
            </a>
          ) : (
            <div className="u-inline-block u-text-first-uppercase u-font-weight-500">{link.displayName}</div>
          )}
        </li>
      ))}
    </ol>
  )
}

export default Breadcrumb
